import React from "react";

export default ({ iconName, className }) =>
    <svg role="img" className={ className }>
        <use xlinkHref={ "/sprite.svg#sprite-" + iconName }/>
    </svg>;